export default __webpack_public_path__ + "images/MK.b2b66a5.png";